module.exports = __webpack_public_path__ + "static/media/logo-footer.2efc4d8b.png";